module.exports = __webpack_public_path__ + "static/img/wen-wu-cai-shen-bao-ku.a32ced5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/wen-wu-cai-shen-bao-ku.jpg
// module id = gdZU
// module chunks = 1